import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { connectSocket, disconnectSocket, selectIsSocketConnected, selectIsSocketConnecting, selectSocketError } from '../store/socketSlice';
import { selectAuth } from '../store/authSlice';
import { loadFreeRewriteStatus } from '../store/freeRewriteSlice';
import type { AppDispatch } from '../store';

export const useSocket = () => {
  const dispatch = useDispatch<AppDispatch>();
  const auth = useSelector(selectAuth);
  const isConnected = useSelector(selectIsSocketConnected);
  const isConnecting = useSelector(selectIsSocketConnecting);
  const connectionError = useSelector(selectSocketError);
  const hasFetchedFreeRewrite = useRef(false);

  // Подключение к Socket.IO при авторизации
  useEffect(() => {
    const accessToken = localStorage.getItem('accessToken');
    if (auth.isAuthenticated && accessToken && !isConnected && !isConnecting) {
      // console.log('🔐 Пользователь авторизован, подключаемся к Socket.IO...');
      dispatch(connectSocket(accessToken));
    }
  }, [auth.isAuthenticated, isConnected, isConnecting, dispatch]);

  // Загружаем статус бесплатного рерайта сразу после авторизации
  useEffect(() => {
    if (auth.isAuthenticated && !hasFetchedFreeRewrite.current) {
      hasFetchedFreeRewrite.current = true;
      dispatch(loadFreeRewriteStatus());
    }
    if (!auth.isAuthenticated) {
      hasFetchedFreeRewrite.current = false;
    }
  }, [auth.isAuthenticated, dispatch]);

  // Отключение от Socket.IO при выходе из системы
  useEffect(() => {
    if (!auth.isAuthenticated && isConnected) {
      // console.log('🚪 Пользователь вышел из системы, отключаемся от Socket.IO...');
      dispatch(disconnectSocket());
    }
  }, [auth.isAuthenticated, isConnected, dispatch]);

  // Очистка при размонтировании компонента
  useEffect(() => {
    return () => {
      if (isConnected) {
        // console.log('🧹 Компонент размонтируется, отключаемся от Socket.IO...');
        dispatch(disconnectSocket());
      }
    };
  }, [isConnected, dispatch]);

  return {
    isConnected,
    isConnecting,
    connectionError,
    isAuthenticated: auth.isAuthenticated,
  };
};
